<div fxLayout="row" class="main-box">
    <div fxFlex="60" class="middle-box">
        <div style="background: #E1E9FE;padding: 10px; margin-bottom: 15px;">
            <img src="assets/back-icon.svg" style="margin-right: 7px; cursor: pointer;" routerLink="/post-hub">
            <span class="create-competition-text">Create Post</span>
        </div>

        <div style="padding: 10px;">
            <div style="display: none;">
                <div style="display: none;" class="form-text-label">Add Name*</div>
                <mat-form-field style="display: none;" [floatLabel]="'never'" style="width: 300px;">
                    <mat-label
                        style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Type
                        here</mat-label>
                    <textarea class="text-area-style" #message maxlength="28" [(ngModel)]="postName" minlength="2"
                        matInput></textarea>
                    <mat-hint align="end">{{ postName.length }} / 28</mat-hint>
                </mat-form-field>
            </div>
            <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                Create Post For*
            </div>
            <div ngbDropdown>
                <button type="button" class="btn selectpicker" id="dropdownBasic1" ngbDropdownToggle
                    style="flex-direction: row;padding:6px; margin-bottom: 15px;">
                    <img *ngIf="botSelectedImage" [src]="botSelectedImage" width="40" height="40"
                        style="margin-right:10px;border-radius: 50%;" />
                    <div fxLayout="column" style="margin-right: 25px;">
                        <span
                            style="color: #999999; font-size: 12px; font-family: Montserrat; font-weight: 500; letter-spacing: 0.24px; word-wrap: break-word">Creating
                            posts for</span>
                        <span
                            style="width: 100%; color: #0E0E0E; font-size: 14px; font-family: Montserrat; font-weight: 510; letter-spacing: 0.28px; word-wrap: break-word">{{dropdown_botname}}</span>
                    </div>
                    <mat-icon style="margin-left: 5%;color: #386AF6;" fxLayoutAlign="end"
                        *ngIf="!dropdown_icon">keyboard_arrow_down</mat-icon>
                    <mat-icon style="margin-left: 5%;color: #386AF6;" fxLayoutAlign="end"
                        *ngIf="dropdown_icon">keyboard_arrow_up</mat-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="overflow: auto;max-height: 40vh;"
                    class="custom_scrollbar">
                    <button ngbDropdownItem *ngFor="let bots of botListArray; let i=index;" style="font-size: 12px;"
                        class="py-2"
                        (click)="botSelected = bots.bot_id;dropdown_botname = bots.name;botSelectedImage =  allBotConfigurationDetails[i]?.photo">
                        <img *ngIf="allBotConfigurationDetails[i]?.photo" [src]="allBotConfigurationDetails[i]?.photo"
                            width="40" height="40" style="margin-right:10px; border-radius: 50%" />
                        {{bots.name}}
                    </button>
                </div>
            </div>


            <div class="form-text-label" style="margin-bottom: 15px;">Select category</div>
            <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedOption">
                <mat-radio-button [value]="category.value" [checked]="category.checked" style="margin-right: 10px;"
                    *ngFor="let category of selectCategory">
                    <span class="radio-text">{{category.name}}</span>
                </mat-radio-button>
            </mat-radio-group>


            <div *ngIf="selectedOption == 1">
                <div fxLayout="row" style="margin-top: 25px;justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Media <img src="assets/info-tooltip.svg" style="cursor: pointer;">
                    </div>
                    <img *ngIf="!toggleExpandIcon[0]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(0)">
                    <img *ngIf="toggleExpandIcon[0]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(0)">
                </div>

                <div style="display: flex; gap: 10px" *ngIf="toggleExpandIcon[0]">
                    <div *ngIf="selectedMediaName !=''" class="uploaded-media-div">
                        <span class="uploaded-media-text">{{selectedMediaName}}</span>
                        <img src="assets/delete-icon.svg" style="height: 26px; cursor: pointer;"
                            (click)="deleteInputMedia()">
                    </div>
                    <div *ngIf="selectedMediaName ==''" style="display: flex; gap: 10px">
                        <button class="media-upload-btn" (click)="triggerInputImage.click()">
                            <span class="media-upload-btn-txt">Upload Photo</span>
                        </button>
                        <button class="media-upload-btn" (click)="onUploadButtonClick()" >
                            <span class="media-upload-btn-txt">Upload Video</span>
                        </button>
                        <button class="media-upload-btn" (click)="triggerInputGif.click()">
                            <span class="media-upload-btn-txt">Upload Gif</span>
                        </button>
                        <input #triggerInputImage type="file" (change)="inputMediaImage($event)"
                            accept="image/png, image/jpeg" style="display: none;">
                        <!-- <input #triggerInputVideo type="file" (change)="inputMediaVideo($event)"
                            accept="video/mp4,video/mkv, video/x-m4v,video/*" style="display: none;"> -->
                        <input #triggerInputGif type="file" (change)="inputMediaGif($event)"
                            accept="image/gif, image/webp" style="display: none;">
                    </div>
                </div>
                <div fxLayout="row" style="justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Add Post Details*
                    </div>
                    <img *ngIf="!toggleExpandIcon[1]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(1)">
                    <img *ngIf="toggleExpandIcon[1]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(1)">
                </div>
                <div *ngIf="toggleExpandIcon[1]" [formGroup]="createPostForm"
                    style="display: flex;flex-direction: column;align-items: flex-end;">
                    <textarea maxlength="1000" style="background: #FAFAFA; border-radius: 5px; height: 100px;" matInput
                        placeholder="Enter Post Text" formControlName="postContent"></textarea>
                    <mat-hint style="font-size: 10px;"
                        align="end">{{createPostForm.controls['postContent'].value.length}} /1000 </mat-hint>
                </div>
                <div fxLayout="row" style="justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Add CTA
                    </div>
                    <img *ngIf="!toggleExpandIcon[2]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(2)">
                    <img *ngIf="toggleExpandIcon[2]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(2)">
                </div>
                <div *ngIf="toggleExpandIcon[2]" [formGroup]="createPostForm" fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <div fxLayout="column">
                        <span
                            style="color: #0E0E0E; font-size: 10px; font-family: Montserrat; font-weight: 700; letter-spacing: 0.20px; word-wrap: break-word">Button
                            text</span>
                        <mat-form-field [floatLabel]="'never'" style="width: 300px;">
                            <mat-label
                                style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Type
                                button text</mat-label>
                            <textarea class="text-area-style" formControlName="ctaName" matInput></textarea>
                        </mat-form-field>
                    </div>
                    <div fxLayout="column">
                        <div
                            style="color: #0E0E0E; font-size: 10px; font-family: Montserrat; font-weight: 700; letter-spacing: 0.20px; word-wrap: break-word">
                            Link</div>
                        <mat-form-field [floatLabel]="'never'" style="width: 300px;">
                            <mat-label
                                style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Add
                                Link</mat-label>
                            <textarea class="text-area-style" formControlName="ctaLink" matInput></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>


            <div *ngIf="selectedOption == 2" [formGroup]="createPollForm">
                <div fxLayout="row" style="margin-top: 25px;justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Attach Image <img src="assets/info-tooltip.svg" style="cursor: pointer;">
                    </div>
                    <img *ngIf="!toggleExpandIcon[1]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(1)">
                    <img *ngIf="toggleExpandIcon[1]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(1)">
                </div>
                <div style="display: flex; gap: 10px" *ngIf="toggleExpandIcon[1]">
                    <div *ngIf="selectedMediaName.length!=0" class="group-image">
                        <div *ngIf="selectedMediaName !=''" class="uploaded-media-div">
                            <span class="uploaded-media-text">{{selectedMediaName}}</span>
                            <img src="assets/delete-icon.svg" style="height: 26px; cursor: pointer;"
                                (click)="deleteInputMedia()">
                        </div>
                        <div style="margin-top: 10px;" *ngIf="!isUploaded">
                            <button class="media-upload-btn"  (click)="triggerInputImageMultiple.click()">
                                <span class="media-upload-btn-txt">Upload Image</span>
                            </button>
                        </div>
                        <input #triggerInputImageMultiple type="file" (change)="inputMediaImage($event)"
                            accept="image/png, image/jpeg, image/gif, image/webp" style="display: none;">
                    </div>
                    <div *ngIf="selectedMediaName.length==0" style="display: flex; gap: 10px">
                        <button class="media-upload-btn" (click)="triggerInputImage.click()">
                            <span class="media-upload-btn-txt">Upload Image</span>
                        </button>
                        <input #triggerInputImage type="file" (change)="inputMediaImage($event)"
                            accept="image/png, image/jpeg" style="display: none;">
                    </div> 
                </div> 
                <div fxLayout="row" style="justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Add Post Details*
                    </div>
                    <img *ngIf="!toggleExpandIcon[3]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(3)">
                    <img *ngIf="toggleExpandIcon[3]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(3)">
                </div>
                <div *ngIf="toggleExpandIcon[3]">
                    <div fxLayout="row" style="width: 50%;" fxLayoutAlign="space-between">
                        <div>
                            <span class="sub-heading-text">Multiple Answers</span>
                            <p
                                style="width: 100%; height: 100%; color: #808485; font-size: 12px; font-family: Montserrat; font-weight: 400; word-wrap: break-word">
                                If turned on, users can vote multiple choice.</p>
                        </div>
                        <mat-slide-toggle (change)="onValChange($event)" color="primary"></mat-slide-toggle>
                    </div>
                    <div class="sub-heading-text">Add Poll Questions</div>
                    <mat-form-field [floatLabel]="'never'" style="width: 50%;">
                        <mat-label
                            style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Add
                            Question</mat-label>
                        <textarea class="text-area-style" maxlength="140" formControlName="questionText"
                            matInput></textarea>
                        <mat-hint align="end">{{ createPollForm.get('questionText').value.length }} / 140</mat-hint>
                    </mat-form-field>

                    <div *ngFor="let option of pollOptions; let i = index">
                        <div class="sub-heading-text">
                            {{option.name}}
                        </div>
                        <mat-form-field [floatLabel]="'never'" style="width: 50%;">
                            <mat-label
                                style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Add
                                here</mat-label>
                            <!-- <div fxLayout="row" fxLayoutAlign="space-around center"> -->
                            <textarea *ngIf="option.key=='option1'" class="text-area-style" maxlength="80"
                                formControlName="option1" matInput></textarea>
                            <textarea *ngIf="option.key=='option2'" class="text-area-style" maxlength="80"
                                formControlName="option2" matInput></textarea>
                            <textarea *ngIf="option.key=='option3'" class="text-area-style" maxlength="80"
                                formControlName="option3" matInput></textarea>
                            <textarea *ngIf="option.key=='option4'" class="text-area-style" maxlength="80"
                                formControlName="option4" matInput></textarea>
                            <textarea *ngIf="option.key=='option5'" class="text-area-style" maxlength="80"
                                formControlName="option5" matInput></textarea>
                            <!-- </div> -->
                            <mat-hint align="end">{{ createPollForm.get(option.key).value.length }} / 80</mat-hint>
                        </mat-form-field>
                        <img *ngIf="i>2 || (!createPollForm.get('isMultiple').value && i>1)"
                            style="margin-left: 50px; cursor: pointer;" src="assets/cross.svg"
                            (click)="removeOptionWithIndex(i)">
                    </div>
                    <div class="add-option-text" [ngStyle]="pollOptions.length ==5 && {'color': '#91aaee'}"
                        (click)="addOptions()">+ Add another option</div>
                </div>
                <div fxLayout="row" style="justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        End Date*
                    </div>
                    <img *ngIf="!toggleExpandIcon[4]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(4)">
                    <img *ngIf="toggleExpandIcon[4]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(4)">
                </div>
                <div *ngIf="toggleExpandIcon[4]" style="display: flex;align-items: baseline; gap: 10px;">
                    <!-- <mat-form-field appearance="standard" class="custom-mat-form-field">
                        <button class="btn mx-1 filter-btn col-md-3"
                            style="display:inline-flex;justify-content: center;width: 80%" id="reportrange" type="button"
                            (click)="picker.open()">
                            <div style="display: flex; gap: 10px;" *ngIf="!createPollForm.get('endDate').value">
                                <img src="assets/calender.svg">
                                <span style="color: #386AF6; font-size: 14px; font-family: Montserrat;">Select date</span>
                            </div>
                            <span *ngIf="createPollForm.get('endDate').value">{{createPollForm.get('endDate').value | dateTransform : 'std'}}</span>
                        </button>
                        <input [formControl]="endDate" min]="minEndDate" (dateChange)="onEndDateChange($event)" matInput [matDatepicker]="picker" hidden>
                        <mat-datepicker-toggle matIconSuffix [for]="picker" hidden></mat-datepicker-toggle>
                        <mat-datepicker #picker hidden></mat-datepicker>
                    </mat-form-field> -->
                    <mat-form-field>
                        <button class="mx-1 col-md-3" style="display:inline-flex;justify-content: center;width: 100%;align-items: center; border: 1px solid #ECECEC;border-radius: 8px;
                    background: white; height: 56px;" id="reportrange" type="button" (click)="picker.open()">
                            <div style="display: flex; gap: 10px;">
                                <img src="assets/calender.svg">
                                <span *ngIf="!createPollForm.get('endDate').value"
                                    style="color: #999999; font-size: 14px; font-family: Montserrat;">Select date</span>
                                <span *ngIf="createPollForm.get('endDate').value">{{createPollForm.get('endDate').value
                                    | dateTransform : 'std'}}</span>
                            </div>
                            <input matInput [min]="minEndDate" [matDatepicker]="picker"
                                (dateChange)="onEndDateChange($event)" [formControl]="endDate" hidden>
                            <mat-datepicker-toggle matSuffix [for]="picker">
                                <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #picker hidden></mat-datepicker>
                        </button>
                    </mat-form-field>
                    <button
                        style="border: 1px solid #ECECEC;border-radius: 8px;height: 56px;padding-left: 10px;padding-right: 10px;background: white;">
                        <span>
                            <img src="assets/clock.svg" style="margin-right: 10px;">
                        </span>
                        <mat-form-field [floatLabel]="'never'">
                            <mat-label style="color: #0E0E0E;">Select Time</mat-label>
                            <mat-select [(value)]="selectedEndTime" (selectionChange)="endTimeTrigger($event)">
                                <mat-option *ngFor="let time of times" [value]="time">
                                    {{time}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </button>

                </div>
                <div fxLayout="row" style="justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Add CTA
                    </div>
                    <img *ngIf="!toggleExpandIcon[2]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(2)">
                    <img *ngIf="toggleExpandIcon[2]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(2)">
                </div>
                <div *ngIf="toggleExpandIcon[2]" [formGroup]="createPollForm" fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <div fxLayout="column">
                        <span
                            style="color: #0E0E0E; font-size: 10px; font-family: Montserrat; font-weight: 700; letter-spacing: 0.20px; word-wrap: break-word">Button
                            text</span>
                        <mat-form-field [floatLabel]="'never'" style="width: 300px;">
                            <mat-label
                                style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Type
                                button text</mat-label>
                            <textarea class="text-area-style" formControlName="ctaName" matInput></textarea>
                        </mat-form-field>
                    </div>
                    <div fxLayout="column">
                        <div
                            style="color: #0E0E0E; font-size: 10px; font-family: Montserrat; font-weight: 700; letter-spacing: 0.20px; word-wrap: break-word">
                            Link</div>
                        <mat-form-field [floatLabel]="'never'" style="width: 300px;">
                            <mat-label
                                style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Add
                                Link</mat-label>
                            <textarea class="text-area-style" formControlName="ctaLink" matInput></textarea>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="isSingleTypePost" fxLayout="row" style="justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Custom Response Label
                    </div>
                    <img *ngIf="!toggleExpandIcon[6]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(6)">
                    <img *ngIf="toggleExpandIcon[6]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(6)">
                </div>
                <div *ngIf="toggleExpandIcon[6]" [formGroup]="createPollForm" fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                    <div style="flex: 1;">
                      <mat-form-field [floatLabel]="'never'" style="width: 400px;">
                        <mat-label style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">
                          Add Custom Response Label
                        </mat-label>
                        <textarea class="text-area-style" formControlName="customResponse" style="height: 15px;" matInput></textarea>
                        <mat-hint align="end">{{ createPollForm.get('customResponse').value.length }} / 10</mat-hint>
                      </mat-form-field>
                    </div>
                </div>

            </div>

            <div *ngIf="selectedOption == 3" [formGroup]="createQandAForm" style="margin-top: 10px;            ">
                <div fxLayout="row" style="margin-top: 25px;justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Attach Image <img src="assets/info-tooltip.svg" style="cursor: pointer;">
                    </div>
                    <img *ngIf="!toggleExpandIcon[1]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(1)">
                    <img *ngIf="toggleExpandIcon[1]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(1)">
                </div>
                <div style="display: flex; gap: 10px" *ngIf="toggleExpandIcon[1]">
                    <div *ngIf="selectedMediaName.length!=0" class="group-image">
                        <div *ngIf="selectedMediaName !=''" class="uploaded-media-div">
                            <span class="uploaded-media-text">{{selectedMediaName}}</span>
                            <img src="assets/delete-icon.svg" style="height: 26px; cursor: pointer;"
                                (click)="deleteInputMedia()">
                        </div>
                        <div style="margin-top: 10px;" *ngIf="!isUploaded">
                            <button class="media-upload-btn"  (click)="triggerInputImageMultiple.click()">
                                <span class="media-upload-btn-txt">Upload Image</span>
                            </button>
                        </div>
                        <input #triggerInputImageMultiple type="file" (change)="inputMediaImage($event)"
                            accept="image/png, image/jpeg, image/gif, image/webp" style="display: none;">
                    </div>
                    <div *ngIf="selectedMediaName.length==0" style="display: flex; gap: 10px">
                        <button class="media-upload-btn" (click)="triggerInputImage.click()">
                            <span class="media-upload-btn-txt">Upload Image</span>
                        </button>
                        <input #triggerInputImage type="file" (change)="inputMediaImage($event)"
                            accept="image/png, image/jpeg" style="display: none;">
                    </div> 
                </div> 
                <div fxLayout="row" style="justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Add Q&A Details*
                    </div>
                    <img *ngIf="!toggleExpandIcon[5]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(5)">
                    <img *ngIf="toggleExpandIcon[5]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(5)">
                </div>
                <div *ngIf="toggleExpandIcon[5]">
                    <div class="sub-heading-text">Question</div>
                    <mat-form-field [floatLabel]="'never'" style="width: 50%;">
                        <mat-label
                            style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Add
                            Question</mat-label>
                        <textarea class="text-area-style" maxlength="140" formControlName="questionText"
                            matInput></textarea>
                        <mat-hint align="end">{{ createQandAForm.get('questionText').value.length }} / 140</mat-hint>
                    </mat-form-field>

                    <div *ngFor="let option of qandAOptions; let i = index">
                        <div class="sub-heading-text">
                            {{option.name}}
                        </div>
                        <mat-form-field [floatLabel]="'never'" style="width: 70%;">
                            <mat-label
                                style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Add
                                here</mat-label>
                            <div fxLayout="row" style="gap: 20px;">
                                <div
                                    style=" display: flex; flex-direction:column; align-items: flex-end; width: 85%; gap: 10px;">
                                    <!-- <div fxLayout="row" fxLayoutAlign="space-around center"> -->
                                    <textarea *ngIf="option.key=='option1'" class="text-area-style" maxlength="20"
                                        formControlName="option1" matInput></textarea>
                                    <textarea *ngIf="option.key=='option2'" class="text-area-style" maxlength="20"
                                        formControlName="option2" matInput></textarea>
                                    <textarea *ngIf="option.key=='option3'" class="text-area-style" maxlength="20"
                                        formControlName="option3" matInput></textarea>
                                    <textarea *ngIf="option.key=='option4'" class="text-area-style" maxlength="20"
                                        formControlName="option4" matInput></textarea>
                                    <mat-hint align="end" style="font-size: 10px;">{{
                                        createQandAForm.get(option.key).value.length }} / 20</mat-hint>
                                </div>

                                <div class="choose-correct">
                                    <input type="radio" name="correctOption" [value]="i+1" (click)="correctOption = i+1"
                                        [checked]="correctOption == i+1"
                                        [attr.disabled]="!createQandAForm.get(option.key).value ? '' : null">
                                    <label
                                        style="color: #4F4F4F; font-size: 12px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">Correct
                                        answer</label>
                                </div>
                            </div>
                            <!-- </div> -->
                        </mat-form-field>
                    </div>
                    <div
                        style="color: #808485; font-size: 12px; font-family: Montserrat; font-weight: 400; word-wrap: break-word">
                        Note: Please make sure you have selected the correct answer</div>
                </div>
                <div fxLayout="row" style="justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Add CTA
                    </div>
                    <img *ngIf="!toggleExpandIcon[2]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(2)">
                    <img *ngIf="toggleExpandIcon[2]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(2)">
                </div>
                <div *ngIf="toggleExpandIcon[2]" [formGroup]="createQandAForm" fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <div fxLayout="column">
                        <span
                            style="color: #0E0E0E; font-size: 10px; font-family: Montserrat; font-weight: 700; letter-spacing: 0.20px; word-wrap: break-word">Button
                            text</span>
                        <mat-form-field [floatLabel]="'never'" style="width: 300px;">
                            <mat-label
                                style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Type
                                button text</mat-label>
                            <textarea class="text-area-style" formControlName="ctaName" matInput></textarea>
                        </mat-form-field>
                    </div>
                    <div fxLayout="column">
                        <div
                            style="color: #0E0E0E; font-size: 10px; font-family: Montserrat; font-weight: 700; letter-spacing: 0.20px; word-wrap: break-word">
                            Link</div>
                        <mat-form-field [floatLabel]="'never'" style="width: 300px;">
                            <mat-label
                                style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">Add
                                Link</mat-label>
                            <textarea class="text-area-style" formControlName="ctaLink" matInput></textarea>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="row" style="justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Add Explanation
                    </div>
                    <img *ngIf="!toggleExpandIcon[6]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(6)">
                    <img *ngIf="toggleExpandIcon[6]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(6)">
                </div>
                <div *ngIf="toggleExpandIcon[6]" [formGroup]="createQandAForm" fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                    <div style="flex: 1;">
                      <p class="form-text-label">Explanation</p>
                      <mat-form-field [floatLabel]="'never'" style="width: 400px;">
                        <mat-label style="color: #999999; font-size: 14px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.20px; word-wrap: break-word">
                          Add Explanation
                        </mat-label>
                        <textarea class="text-area-style" formControlName="explanationField" style="height: 100px;" matInput maxlength="500"></textarea>
                        <mat-hint align="end">{{ createQandAForm.get('explanationField').value.length }} / 500</mat-hint>
                      </mat-form-field>
                    </div>
                </div>                                    
            </div>


            <div *ngIf="isSchedulePost" class="form-text-label" style="margin-bottom: 0px; margin-top: 15px;">
                <div fxLayout="row" style="justify-content: space-between; ">
                    <div class="form-text-label" style="margin-bottom: 15px; margin-top: 15px;">
                        Schedule Post*
                    </div>
                    <img *ngIf="!toggleExpandIcon[6]" src="assets/plus.svg" style="cursor: pointer;"
                        (click)="expandField(6)">
                    <img *ngIf="toggleExpandIcon[6]" src="assets/minus.svg" style="cursor: pointer;"
                        (click)="expandField(6)">
                </div>
            </div>
            <div *ngIf="toggleExpandIcon[6] && isSchedulePost" class="schedule-div">
                <mat-form-field *ngIf="toggleExpandIcon[6]">
                    <button class="mx-1 col-md-3" style="display:inline-flex;justify-content: center;width: 100%;align-items: center; border: 1px solid #ECECEC;border-radius: 8px;
            background: white; height: 56px;" id="reportrange" type="button" (click)="pickerSchedule.open()">
                        <div style="display: flex; gap: 10px;">
                            <img src="assets/calender.svg">
                            <span *ngIf="!scheduleDate.value"
                                style="color: #999999; font-size: 14px; font-family: Montserrat;">Select date</span>
                            <span *ngIf="scheduleDate.value">{{scheduleDate.value| dateTransform : 'std'}}</span>
                        </div>
                        <input matInput [min]="minEndDate" [matDatepicker]="pickerSchedule" [formControl]="scheduleDate" hidden>
                        <mat-datepicker-toggle matSuffix [for]="pickerSchedule">
                            <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #pickerSchedule hidden></mat-datepicker>
                    </button>
                </mat-form-field>
                <div class="mx-1 col-md-3" style="display:inline-flex;justify-content: center;width: 25%;align-items: center; border: 1px solid #ECECEC;border-radius: 8px;
                background: white; height: 56px;" type="button">
                     <img src="assets/clock.svg" style="margin-right: 10px;">
                    <input type="time" [(ngModel)]="scheduledTime"  id="timepicker">
                </div>
            </div>

        </div>
        <div fxLayout="column" style="margin-top: 20px;">
            <div fxLayout="column">
                <div fxLayout="row" style="display: flex;flex-direction: row; justify-content: space-around;">
                    <button *ngIf="!validateAllField()" type="button" class="verify-btn" fxLayoutAlign="center center"
                        style="width: 235px;height: 45px;background: #C3D2FC; color:#fff">Generate Preview</button>
                    <button *ngIf="validateAllField()" type="button" class="verify-btn" fxLayoutAlign="center center"
                        style="width: 235px;height: 45px;background: #386AF6; color:#fff"
                        (click)="genratePreview()">Generate Preview
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div fxFlex="40%" style="padding: 30px;">

        <mat-card *ngIf="!showPublish">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="center" style="gap: 7px;">
                    <img src="assets/swift-chat-logo.svg">
                    <div fxLayout="column">
                        <span class="form-text-label">SwiftChat</span>
                        <span
                            style="color: #999999; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 15.60px; word-wrap: break-word">
                            1 day ago</span>
                    </div>
                </div>
                <img src="assets/three-dot.svg">
            </div>
            <mat-card-content style="padding: 10px;margin-bottom: 0px;">
                <div
                    style="width: 100%; height: 200px; background: linear-gradient(0deg, #F4F6FA 0%, #F4F6FA 100%); border-radius: 6px">

                </div>
            </mat-card-content>
        </mat-card>

        <mat-card *ngIf="selectedOption==1 && showPublish">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="center" style="gap: 7px;">
                    <img src="assets/swift-chat-logo.svg">
                    <div fxLayout="column">
                        <span class="form-text-label">SwiftChat</span>
                        <span
                            style="color: #999999; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 15.60px; word-wrap: break-word">
                            1 day ago</span>
                    </div>
                </div>
                <img src="assets/three-dot.svg">
            </div>
            <mat-card-content style="padding: 10px;margin-bottom: 0px;">
                <span class="content-style"> {{postDetails?.content.substring(0,120)}} </span>
                <span *ngIf="postDetails?.content.length>120" class="read-more">Read More</span>
                <img *ngIf="selectedMediaName && !isMediaTypeVideo" style="max-height: 200px;" mat-card-image
                    [src]="postDetails?.images" alt="post-photo">
                <img *ngIf="isMediaTypeVideo" mat-card-image [src]="thumbNailLink" alt="post-photo"
                    style="max-height: 200px;">
                <div fxLayout="row">
                    <div class="emoji-class">
                        <img src="assets/love-emoji.svg" alt="love-emoji">
                        <span class="text-style" style="color: #999999; font-size: 11px;">Love</span>
                        <div class="partition-line"></div>
                        <img src="assets/like-emoji.svg">
                        <div style="margin-left: -14px;">😍</div>
                        <img style="margin-left: -14px;" src="assets/love-emoji.svg">
                        <span
                            style="color: #282A30; font-size: 11px; font-family: Montserrat; font-weight: 500; line-height: 21px; word-wrap: break-word">79</span>
                    </div>
                    <div fxLayout="row" style=" align-items: center; gap: 5px;">
                        <img src="assets/share.svg">
                        <span class="text-style" style="color: #999999; font-size: 11px;;">Share</span>
                    </div>
                </div>
                <hr>
                <div *ngIf="createPostForm.get('ctaName').value"
                    style="text-align: center; color: #386AF6; font-size: 14px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; letter-spacing: 0.20px; word-wrap: break-word">
                    {{ postDetails?.ctaName}}</div>
            </mat-card-content>
        </mat-card>


        <mat-card *ngIf="selectedOption!=1 && showPublish">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="center" style="gap: 7px;">
                    <img src="assets/swift-chat-logo.svg">
                    <div fxLayout="column">
                        <span class="form-text-label">SwiftChat</span>
                        <span
                            style="color: #999999; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 15.60px; word-wrap: break-word">
                            1 day ago</span>
                    </div>
                </div>
                <img src="assets/three-dot.svg">
            </div>

            <mat-card-content style="padding: 5px;margin-bottom: 0px;">
                <div class="poll-background">
                    <div>
                        <span class="content-style" style="font-size: 16px; font-weight: 600;">
                            {{postDetails?.content.substring(0,120)}} </span>
                        <span *ngIf="createPostForm.get('postContent').value.length>120" class="read-more">Read
                            More</span>
                    </div>
                    <img *ngIf="selectedMediaName && !isMediaTypeVideo" style="max-height: 200px;" mat-card-image
                    [src]="postDetails?.images" alt="post-photo">
                    <span style="font-weight: 400; font-size: 10px; color: #999999;">Select one</span>


                    <div fxLayout="column">
                        <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex; margin-bottom: 8px;"
                            *ngFor="let option of postDetails?.options; let i= index;">
                            <div
                                style="width: 20px; height: 20px; position: relative; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
                                <div
                                    style="width: 16px; height: 16px; border-radius: 4px; border: 1.20px #386AF6 solid">
                                </div>
                            </div>
                            <div
                                style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 12px; display: inline-flex">
                                <div
                                    style="justify-content: flex-start; align-items: center; gap: 45px; display: inline-flex">
                                    <div
                                        style="color: black; font-size: 13px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">
                                        {{option}}</div>
                                </div>
                                <div style="width: 100%; height: 6px; background: #E1E9FE; border-radius: 8px"></div>
                            </div>
                        </div>
                        <div *ngIf="postDetails?.type === 'poll' && postDetails.custom_response_label" style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex; margin-bottom: 8px;">
                            <div
                                style="width: 20px; height: 20px; position: relative; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
                                <div
                                    style="width: 16px; height: 16px; border-radius: 4px; border: 1.20px #386AF6 solid">
                                </div>
                            </div>
                            <div
                                style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 12px; display: inline-flex">
                                <div
                                    style="justify-content: flex-start; align-items: center; gap: 45px; display: inline-flex">
                                    <div
                                        style="color: black; font-size: 13px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">
                                        {{postDetails.custom_response_label}}</div>
                                </div>
                                <div style="width: 100%; height: 6px; background: #E1E9FE; border-radius: 8px"></div>
                            </div>
                        </div>
                        <div *ngIf="postDetails?.type!='question'"
                            style="color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; line-height: 14.30px; word-wrap: break-word">
                            Last Date - {{postDetails?.expires_at | dateTransform: 'timestamp'}} </div>
                        <div *ngIf="postDetails?.type === 'question'" style="font-size: 12px; word-break: break-word; overflow-wrap: break-word;">
                            <span class="form-text-label">Explanation: </span>{{postDetails.explanationField}}
                        </div>
                    </div>

                </div>
                <div fxLayout="row" style=" align-items: center; gap: 5px;justify-content: flex-end;">
                    <img src="assets/share.svg">
                    <span class="text-style" style="color: #999999; font-size: 11px;;">Share</span>
                </div>
            </mat-card-content>
        </mat-card>
        <button *ngIf="showPublish" type="button" class="verify-btn" fxLayoutAlign="center center"
            style="height: 45px;background: #386AF6; color:#fff" (click)="publishPost()">Publish
        </button>
    </div>
</div>